import _jQuery from 'jquery';
import moment from 'moment';

window.$ = window.jQuery = _jQuery;
window.$m = moment;
